import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-166">
      <div className="max-w-4xl mx-auto text-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-168">
          <div className="inline-flex items-center justify-center mb-6" data-id="element-169">
            <Clock className="w-12 h-12 text-red-400/80" data-id="element-170" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8" data-id="element-171">
            Actúa Ahora — Esto Es Lo Que Pierdes Cada Día
          </h2>

          <p className="text-xl text-slate-300 mb-10" data-id="element-172">
            Cada día que sigues sin un sistema de promoción claro es un día que:
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-12" data-id="element-173">
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-174">
              <p className="text-slate-300" data-id="element-175">Creas contenido que no convierte</p>
            </div>
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-176">
              <p className="text-slate-300" data-id="element-177">Mandas tráfico que no compra</p>
            </div>
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-178">
              <p className="text-slate-300" data-id="element-179">Pierdes comisiones que alguien más está ganando en tu lugar</p>
            </div>
          </div>

          <p className="text-2xl font-serif text-white" data-id="element-180">
            El mercado no espera. Los compradores no esperan.{' '}
            <span className="text-gold-400" data-id="element-181">
              Tu ventana de oportunidad tampoco.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}